import { IAPM } from './apm.types';

export function createNoopAPM(): IAPM {
    return {
        noticeError() {},
        addPageAction() {},
        setCustomAttribute() {},
        logAction() {},
        registerBtnClick() {},
        shutdown() {},
    };
}
